import React from 'react'
import About from '../components/About/About'
import Nav from '../components/Nav/Nav'

function AboutPage() {
    
    return (
        <section>
            <Nav/>
            <div className="container-box">
                <About/>
            </div>
        </section>
    )
}

export default AboutPage
